export default "__VITE_ASSET__b8897eb3__"